var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1559 -376)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1559 376)",
    fill: "#734bd1"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(1575 399)",
    fill: "#fff",
    fontSize: 18,
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.355,
    y: 0
  }, "EN")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangIcon);
export default __webpack_public_path__ + "static/media/langIcon.a193e2b87ed40ff4fe574ed1021cf43d.svg";
export { ForwardRef as ReactComponent };